import "./styles/main.scss";
import Header from "Dashboard/components/Header";
import Toolbox from "./scenes/Main/components/Toolbox";
import TopSection from "./scenes/Main/components/TopSection";
import BottomSection from "./scenes/Financials/components/BottomSection";
import { FullUser } from "authentication/domain/FullUser";
import { useEffect } from "react";
import { useAppDispatch } from "hooks/hooks";
import { setProjectPermission } from "./scenes/Main/main.slice";

interface IProps {
  user?: FullUser;
}

const Projects = (props: IProps) => {
  const { user } = props;
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (user?.allAllowedModules) {
      dispatch(setProjectPermission(user?.allAllowedModules));
    }
  }, [dispatch, user?.allAllowedModules]);

  return (
    <>
      <Header title="Projekti" />
      <Toolbox />
      <main id="projects">
        <TopSection />
        <BottomSection />
      </main>
    </>
  );
};

export default Projects;
